import styled from 'styled-components';

import { colors } from '../../constants';

export const SubmitButton = styled.button.attrs(() => ({
    type: 'submit',
}))`
    appearance: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    padding: 0 70px;
    height: 48px;
    width: 210px;
    border-radius: 3px;
    font-family: inherit;
    font-size: 16px;
    text-align: center;
    color: ${colors.white};
    background: ${colors.black};
    cursor: pointer;
    transition: background-color 0.2s linear;

    :focus {
        outline: 0;
    }

    // Overriding environment hover styles
    :hover {
        text-decoration: none;
        color: ${colors.white};
        background-color: ${colors.blackHover};
    }

    :disabled {
        background: ${colors.greyContrast};
        cursor: default;
    }
`;
